module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 15
// module chunks = 0